/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ExternalLink, LegacyDataTable, LegacyDataTableBody, LegacyDataTableRow, LegacyDataTableRowColumn, LegacyDataTableRowHeaderColumn, Tooltip } from "@octopusdeploy/design-system-components";
import type { OctopusPackageVersionBuildInformationMappedResource } from "@octopusdeploy/octopus-server-client";
import CommitDetails from "~/components/Commits/CommitDetails";
import type { DataBaseComponentState } from "~/components/DataBaseComponent";
import DataBaseComponent from "~/components/DataBaseComponent";
import SimpleExpander from "~/components/SimpleExpander/SimpleExpander";
import WorkItems from "~/components/WorkItems/WorkItems";
import DateFormatter from "~/utils/DateFormatter";
import styles from "./styles.module.less";
interface BuildInformationProps {
    data: OctopusPackageVersionBuildInformationMappedResource;
    heading?: string;
}
export default class BuildInformationTable extends DataBaseComponent<BuildInformationProps, DataBaseComponentState> {
    constructor(props: BuildInformationProps) {
        super(props);
        this.state = {};
    }
    buildTable() {
        return (<LegacyDataTable>
                <LegacyDataTableBody>
                    <LegacyDataTableRow>
                        <LegacyDataTableRowHeaderColumn>Build Environment</LegacyDataTableRowHeaderColumn>
                        <LegacyDataTableRowColumn>{this.props.data.BuildEnvironment}</LegacyDataTableRowColumn>
                    </LegacyDataTableRow>
                    <LegacyDataTableRow>
                        <LegacyDataTableRowHeaderColumn>Build</LegacyDataTableRowHeaderColumn>
                        <LegacyDataTableRowColumn>
                            <ExternalLink href={this.props.data.BuildUrl}>{this.props.data.BuildNumber}</ExternalLink>
                        </LegacyDataTableRowColumn>
                    </LegacyDataTableRow>
                    {this.props.data && this.props.data.Branch && this.props.data.Branch.length > 0 && (<LegacyDataTableRow>
                            <LegacyDataTableRowHeaderColumn>Branch</LegacyDataTableRowHeaderColumn>
                            <LegacyDataTableRowColumn>{this.props.data.Branch}</LegacyDataTableRowColumn>
                        </LegacyDataTableRow>)}
                    <LegacyDataTableRow>
                        <LegacyDataTableRowHeaderColumn>Created</LegacyDataTableRowHeaderColumn>
                        <LegacyDataTableRowColumn>
                            <Tooltip content={DateFormatter.dateToLongFormat(this.props.data.Created)!}>{DateFormatter.dateToShortFormat(this.props.data.Created)}</Tooltip>
                        </LegacyDataTableRowColumn>
                    </LegacyDataTableRow>
                    {this.props.data && this.props.data.Commits && this.props.data.Commits.length > 0 && (<LegacyDataTableRow>
                            <LegacyDataTableRowHeaderColumn>Commits</LegacyDataTableRowHeaderColumn>
                            <LegacyDataTableRowColumn>
                                <CommitDetails data={this.props.data.Commits}/>
                            </LegacyDataTableRowColumn>
                        </LegacyDataTableRow>)}
                    {this.props.data && this.props.data.WorkItems && this.props.data.WorkItems.length > 0 && (<LegacyDataTableRow>
                            <LegacyDataTableRowHeaderColumn>Work Items</LegacyDataTableRowHeaderColumn>
                            <LegacyDataTableRowColumn>
                                <WorkItems data={this.props.data.WorkItems}/>
                            </LegacyDataTableRowColumn>
                        </LegacyDataTableRow>)}
                </LegacyDataTableBody>
            </LegacyDataTable>);
    }
    render() {
        return this.props.heading ? (<SimpleExpander title={<div className={styles.metadataPackageTitle}>{this.props.heading}</div>} key={this.props.data.PackageId} errorKey={this.props.data.PackageId}>
                {this.buildTable()}
            </SimpleExpander>) : (this.buildTable());
    }
    static displayName = "BuildInformationTable";
}
